/**
 * Re-export the task/connection hooks from WebSocketContext
 *
 * This provides a cleaner import path:
 * import { useTaskProgress } from '@/hooks/useTaskProgress';
 */

export {
  useTaskProgress,
  useTaskEvents,
  useWebSocketConnection,
} from '../context/WebSocketContext';
export type {
  TaskProgress,
  ConnectionState,
  TaskEventsValue,
  WebSocketConnectionValue,
} from '../context/WebSocketContext';
